


// import React, { useState, useEffect } from "react";
// import { useParams, useHistory } from "react-router-dom";
// import { styled } from "@mui/material/styles";
// import Box from "@mui/material/Box";
// import TextField from "@mui/material/TextField";
// import { getDatabase, ref, get, set, onValue, push } from "firebase/database";
// import { app, database } from "../../Firebase/firebase.config";
// import SideNav from "../SideNav";
// import { toast, Toaster } from "react-hot-toast";
// import dp from "../../image/dp.png";
// import "./editprofile.css";

// const DrawerHeader = styled("div")(({ theme }) => ({
//   display: "flex",
//   alignItems: "center",
//   justifyContent: "flex-end",
//   padding: theme.spacing(0, 1),
//   ...theme.mixins.toolbar,
// }));

// const convertTo12HourFormat = (time24) => {
//   if (!time24) return "";
//   let [hours, minutes] = time24.split(":");
//   hours = parseInt(hours, 10);
//   const suffix = hours >= 12 ? "PM" : "AM";
//   hours = hours % 12 || 12;
//   return `${hours}:${minutes} ${suffix}`;
// };

// const MONTHS = [
//   "January","February","March","April","May","June",
//   "July","August","September","October","November","December",
// ];

// /* Normalize any stored date → YYYY-MM-DD for <input type="date"> */
// const toInputDate = (val) => {
//   if (!val) return "";
//   if (typeof val === "string" && val.includes("T")) return val.split("T")[0];
//   if (/^\d{4}-\d{2}-\d{2}$/.test(val)) return val;
//   if (/^\d{2}-\d{2}-\d{4}$/.test(val)) {
//     const [d, m, y] = val.split("-");
//     return `${y}-${m}-${d}`;
//   }
//   if (/^\d{2}\/\d{2}\/\d{4}$/.test(val)) {
//     const [m, d, y] = val.split("/");
//     return `${y}-${m}-${d}`;
//   }
//   return val;
// };

// /* YYYY-MM-DD → "15 March 2026" */
// const prettyDate = (val) => {
//   const normalized = toInputDate(val);
//   if (!normalized) return "";
//   const [y, m, d] = normalized.split("-");
//   const monthName = MONTHS[parseInt(m, 10) - 1] || m;
//   return `${parseInt(d, 10)} ${monthName} ${y}`;
// };

// /* Compress image → base64 string (keeps DB size small) */
// const compressImage = (file, maxWidth = 400, quality = 0.75) =>
//   new Promise((resolve, reject) => {
//     const reader = new FileReader();
//     reader.onerror = reject;
//     reader.onload = (e) => {
//       const img = new Image();
//       img.onerror = reject;
//       img.onload = () => {
//         const scale = Math.min(1, maxWidth / img.width);
//         const canvas = document.createElement("canvas");
//         canvas.width = Math.round(img.width * scale);
//         canvas.height = Math.round(img.height * scale);
//         canvas.getContext("2d").drawImage(img, 0, 0, canvas.width, canvas.height);
//         resolve(canvas.toDataURL("image/jpeg", quality));
//       };
//       img.src = e.target.result;
//     };
//     reader.readAsDataURL(file);
//   });

// /* ── Reusable Field ── */
// const Field = ({ label, children }) => (
//   <div className="ep-form-group">
//     <label className="ep-label">{label}</label>
//     {children}
//   </div>
// );

// /* ── Reusable Section ── */
// const Section = ({ icon, title, children }) => (
//   <div className="ep-section">
//     <div className="ep-section-header">
//       <div className="ep-section-icon">{icon}</div>
//       <h3>{title}</h3>
//     </div>
//     <div className="ep-section-body">{children}</div>
//   </div>
// );

// const EditProfile = () => {
//   const { id } = useParams();
//   const history = useHistory();

//   const [formValues, setFormValues] = useState({
//     Prefix: "", First: "", Middle: "", Last: "",
//     Email: "", Mobile: "", Description: "",
//     Qualification1: "", Speciality: "",
//     Speciality2: "", Speciality3: "", Speciality4: "",
//     ClinicName: "", ClinicAddress: "", City: "",
//     State: "", Country: "", Locality: "",
//     Experience: "", MorStartTime: "", MorEndTime: "",
//     EveStartTime: "", EveEndTime: "",
//     DateOfBirth: "", Age: "",
//     Fees: "", // ── Consultation fee
//   });

//   const [scheduleValues, setScheduleValues] = useState({
//     startDate: "", endDate: "",
//     morningStartTime: "", morningEndTime: "",
//     eveningStartTime: "", eveningEndTime: "",
//     isActive: true,
//   });

//   const [profileImageFile, setProfileImageFile] = useState(null);
//   const [profileImageUrl, setProfileImageUrl] = useState("");
//   const [clinicImageFiles, setClinicImageFiles] = useState([]);
//   const [clinicImageUrls, setClinicImageUrls] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [uploadingProfileImage, setUploadingProfileImage] = useState(false);
//   const [uploadingClinicImages, setUploadingClinicImages] = useState(false);

//   useEffect(() => {
//     if (!id) return;
//     const dbRef = getDatabase(app);

//     const fetchProfile = async () => {
//       try {
//         const snap = await get(ref(dbRef, `doctor/${id}`));
//         if (snap.exists()) setFormValues(snap.val());
//       } catch {
//         toast.error("Failed to fetch profile");
//       }
//     };

//     const fetchSchedule = async () => {
//       try {
//         const snap = await get(ref(dbRef, `doctor/${id}/schedule`));
//         if (snap.exists()) {
//           const data = snap.val();
//           const key = Object.keys(data)[0];
//           if (key) setScheduleValues(data[key]);
//         } else {
//           setScheduleValues({
//             startDate: new Date().toISOString().split("T")[0],
//             endDate: new Date(
//               new Date().setFullYear(new Date().getFullYear() + 1)
//             ).toISOString().split("T")[0],
//             morningStartTime: "10:00",
//             morningEndTime: "12:00",
//             eveningStartTime: "15:00",
//             eveningEndTime: "20:00",
//             isActive: true,
//           });
//         }
//       } catch (e) {
//         console.error(e);
//       }
//     };

//     /* Real-time listeners → images auto-load on every login */
//     const unsubProfile = onValue(
//       ref(database, `Profile/${id}/Profile`),
//       (snap) => setProfileImageUrl(snap.val()?.base64 || "")
//     );
//     const unsubClinic = onValue(
//       ref(database, `Profile/${id}/Clinic`),
//       (snap) => setClinicImageUrls(snap.val()?.images || [])
//     );

//     fetchProfile();
//     fetchSchedule();
//     return () => { unsubProfile(); unsubClinic(); };
//   }, [id]);

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormValues((p) => ({ ...p, [name]: value }));
//   };

//   const handleScheduleChange = (e) => {
//     const { name, value } = e.target;
//     setScheduleValues((p) => ({ ...p, [name]: value }));
//   };

//   /* Profile photo: compress → base64 → save to Realtime DB */
//   const handleProfileImageUpload = async () => {
//     if (!profileImageFile) { toast.error("Please choose an image"); return; }
//     setUploadingProfileImage(true);
//     try {
//       const base64 = await compressImage(profileImageFile, 400, 0.75);
//       await set(ref(database, `Profile/${id}/Profile`), { base64 });
//       setProfileImageUrl(base64);
//       toast.success("Profile photo saved!");
//     } catch (err) {
//       console.error(err);
//       toast.error("Save failed: " + (err.message || "unknown error"));
//     }
//     setUploadingProfileImage(false);
//   };

//   const handleProfileImageDelete = async () => {
//     if (!profileImageUrl) { toast.error("No image to delete"); return; }
//     try {
//       await set(ref(database, `Profile/${id}/Profile`), { base64: null });
//       setProfileImageUrl("");
//       toast.success("Photo removed");
//     } catch {
//       toast.error("Delete failed");
//     }
//   };

//   /* Clinic photos: compress → base64 array → save to Realtime DB */
//   const handleClinicImageUpload = async () => {
//     if (!clinicImageFiles.length) { toast.error("Please choose images"); return; }
//     setUploadingClinicImages(true);
//     try {
//       const newBase64s = await Promise.all(
//         clinicImageFiles.map((f) => compressImage(f, 600, 0.7))
//       );
//       const updated = [...clinicImageUrls, ...newBase64s];
//       await set(ref(database, `Profile/${id}/Clinic`), { images: updated });
//       setClinicImageUrls(updated);
//       toast.success("Clinic photos saved!");
//     } catch (err) {
//       console.error(err);
//       toast.error("Save failed");
//     }
//     setUploadingClinicImages(false);
//   };

//   const handleClinicImageDelete = async (index) => {
//     try {
//       const updated = clinicImageUrls.filter((_, i) => i !== index);
//       await set(ref(database, `Profile/${id}/Clinic`), { images: updated });
//       setClinicImageUrls(updated);
//       toast.success("Image removed");
//     } catch {
//       toast.error("Delete failed");
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     try {
//       const dbRef = getDatabase(app);
//       await set(ref(dbRef, `doctor/${id}`), formValues);
//       const schedRef = ref(dbRef, `doctor/${id}/schedule`);
//       const schedSnap = await get(schedRef);
//       const key = schedSnap.exists()
//         ? Object.keys(schedSnap.val())[0]
//         : push(schedRef).key;
//       await set(ref(dbRef, `doctor/${id}/schedule/${key}`), scheduleValues);
//       toast.success("Profile & schedule saved!");
//     } catch {
//       toast.error("Save failed");
//     }
//     setLoading(false);
//   };

//   const fullName = [formValues.First, formValues.Middle, formValues.Last]
//     .filter(Boolean).join(" ");

//   return (
//     <Box sx={{ display: "flex" }}>
//       <SideNav id={id} />

//       <Box
//         component="main"
//         className="ep-page-bg"
//         sx={{ flexGrow: 1, minWidth: 0, py: 2, px: 0 }}
//       >
//         <DrawerHeader />
//         <Toaster toastOptions={{ duration: 4000 }} />

//         <div className="ep-wrapper">
//           <form onSubmit={handleSubmit}>

//             <div className="ep-header">
//               <h1>My Profile</h1>
//               <div className="ep-header-line" />
//             </div>

//             {/* ── PERSONAL INFO ── */}
//             <div className="ep-section">
//               <div className="ep-section-header">
//                 <div className="ep-section-icon">👤</div>
//                 <h3>Personal Information</h3>
//               </div>
//               <div className="ep-section-body">
//                 <div className="ep-personal-layout">

//                   {/* Photo card */}
//                   <div className="ep-photo-card">
//                     <div className="ep-avatar-wrap">
//                       <img
//                         src={profileImageUrl || dp}
//                         alt="Profile"
//                         className="ep-avatar"
//                       />
//                       <div className="ep-avatar-badge">📷</div>
//                     </div>
//                     {fullName && <div className="ep-photo-name">{fullName}</div>}
//                     <div className="ep-photo-actions">
//                       <input
//                         type="file"
//                         accept="image/*"
//                         className="ep-file-input"
//                         onChange={(e) => setProfileImageFile(e.target.files[0])}
//                       />
//                       <button
//                         type="button"
//                         className="ep-btn ep-btn-primary ep-btn-sm ep-btn-full"
//                         onClick={handleProfileImageUpload}
//                         disabled={uploadingProfileImage}
//                       >
//                         {uploadingProfileImage ? "Saving…" : "📤 Upload Photo"}
//                       </button>
//                       {profileImageUrl && (
//                         <button
//                           type="button"
//                           className="ep-btn ep-btn-danger ep-btn-sm ep-btn-full"
//                           onClick={handleProfileImageDelete}
//                         >
//                           🗑 Remove
//                         </button>
//                       )}
//                     </div>
//                   </div>

//                   {/* Fields */}
//                   <div style={{ display: "flex", flexDirection: "column", gap: "0.85rem" }}>
//                     <div className="ep-grid-3">
//                       <Field label="First Name">
//                         <input
//                           className="ep-input" type="text" name="First"
//                           value={formValues.First} onChange={handleInputChange}
//                           placeholder="First Name" required
//                         />
//                       </Field>
//                       <Field label="Middle Name">
//                         <input
//                           className="ep-input" type="text" name="Middle"
//                           value={formValues.Middle} onChange={handleInputChange}
//                           placeholder="Middle Name"
//                         />
//                       </Field>
//                       <Field label="Last Name">
//                         <input
//                           className="ep-input" type="text" name="Last"
//                           value={formValues.Last} onChange={handleInputChange}
//                           placeholder="Last Name" required
//                         />
//                       </Field>
//                     </div>
//                     <div className="ep-grid-2">
//                       <Field label="Email Address">
//                         <input
//                           className="ep-input" type="email"
//                           value={formValues.Email || ""} disabled placeholder="Email"
//                         />
//                       </Field>
//                       <Field label="Mobile Number">
//                         <input
//                           className="ep-input" type="text" name="Mobile"
//                           value={formValues.Mobile || ""} onChange={handleInputChange}
//                           placeholder="Mobile Number"
//                         />
//                       </Field>
//                     </div>
//                     <div className="ep-grid-2">
//                       <Field label="Date of Birth">
//                         <input
//                           className="ep-input" type="date" name="DateOfBirth"
//                           value={toInputDate(formValues.DateOfBirth)}
//                           onChange={handleInputChange}
//                         />
//                         {formValues.DateOfBirth && (
//                           <span className="ep-date-pretty">
//                             {prettyDate(formValues.DateOfBirth)}
//                           </span>
//                         )}
//                       </Field>
//                       <Field label="Age">
//                         <input
//                           className="ep-input" type="number" name="Age"
//                           value={formValues.Age} onChange={handleInputChange}
//                           placeholder="Age"
//                         />
//                       </Field>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             {/* ── QUALIFICATIONS ── */}
//             <Section icon="🎓" title="Qualifications & Specialities">
//               <div className="ep-grid-2" style={{ marginBottom: "0.85rem" }}>
//                 <Field label="Primary Qualification">
//                   <input
//                     className="ep-input" type="text" name="Qualification1"
//                     value={formValues.Qualification1} onChange={handleInputChange}
//                     placeholder="e.g. MBBS, MD"
//                   />
//                 </Field>
//                 <Field label="Primary Speciality">
//                   <input
//                     className="ep-input" type="text" name="Speciality"
//                     value={formValues.Speciality} onChange={handleInputChange}
//                     placeholder="e.g. Cardiology"
//                   />
//                 </Field>
//               </div>
//               <label className="ep-label" style={{ display: "block", marginBottom: "0.45rem" }}>
//                 Additional Specialities (Optional)
//               </label>
//               <div className="ep-grid-3">
//                 <input className="ep-input" type="text" name="Speciality2"
//                   value={formValues.Speciality2} onChange={handleInputChange} placeholder="Speciality 2" />
//                 <input className="ep-input" type="text" name="Speciality3"
//                   value={formValues.Speciality3} onChange={handleInputChange} placeholder="Speciality 3" />
//                 <input className="ep-input" type="text" name="Speciality4"
//                   value={formValues.Speciality4} onChange={handleInputChange} placeholder="Speciality 4" />
//               </div>
//             </Section>

//             {/* ── CLINIC DETAILS ── */}
//             <Section icon="🏥" title="Clinic Details">
//               <div className="ep-grid-3" style={{ marginBottom: "0.85rem" }}>
//                 <Field label="Clinic Name">
//                   <input className="ep-input" type="text" name="ClinicName"
//                     value={formValues.ClinicName} onChange={handleInputChange} placeholder="Clinic Name" />
//                 </Field>
//                 <Field label="Clinic Address">
//                   <input className="ep-input" type="text" name="ClinicAddress"
//                     value={formValues.ClinicAddress} onChange={handleInputChange} placeholder="Street / Area" />
//                 </Field>
//                 <Field label="Experience (Years)">
//                   <input className="ep-input" type="number" name="Experience"
//                     value={formValues.Experience} onChange={handleInputChange} placeholder="e.g. 5" />
//                 </Field>
//               </div>
//               <div className="ep-grid-4" style={{ marginBottom: "0.85rem" }}>
//                 <Field label="Locality">
//                   <input className="ep-input" type="text" name="Locality"
//                     value={formValues.Locality} onChange={handleInputChange} placeholder="Locality" />
//                 </Field>
//                 <Field label="City">
//                   <input className="ep-input" type="text" name="City"
//                     value={formValues.City} onChange={handleInputChange} placeholder="City" />
//                 </Field>
//                 <Field label="State">
//                   <input className="ep-input" type="text" name="State"
//                     value={formValues.State} onChange={handleInputChange} placeholder="State" />
//                 </Field>
//                 <Field label="Country">
//                   <input className="ep-input" type="text" name="Country"
//                     value={formValues.Country} onChange={handleInputChange} placeholder="Country" />
//                 </Field>
//               </div>

//               {/* ── CONSULTATION FEE ── */}
//               <div className="ep-grid-2">
//                 <Field label="Consultation Fees (₹)">
//                   <input
//                     className="ep-input" type="number" name="Fees"
//                     value={formValues.Fees} onChange={handleInputChange}
//                     placeholder="e.g. 500" min="0"
//                   />
//                 </Field>
//               </div>
//             </Section>

//             {/* ── WORKING SCHEDULE ── */}
//             <Section icon="📅" title="Working Schedule">
//               <div className="ep-grid-2" style={{ marginBottom: "1rem" }}>
//                 <Field label="Schedule Start Date">
//                   <input
//                     className="ep-input" type="date" name="startDate"
//                     value={toInputDate(scheduleValues.startDate)}
//                     onChange={handleScheduleChange} required
//                   />
//                   {scheduleValues.startDate && (
//                     <span className="ep-date-pretty">{prettyDate(scheduleValues.startDate)}</span>
//                   )}
//                 </Field>
//                 <Field label="Schedule End Date">
//                   <input
//                     className="ep-input" type="date" name="endDate"
//                     value={toInputDate(scheduleValues.endDate)}
//                     onChange={handleScheduleChange} required
//                   />
//                   {scheduleValues.endDate && (
//                     <span className="ep-date-pretty">{prettyDate(scheduleValues.endDate)}</span>
//                   )}
//                 </Field>
//               </div>
//               <label className="ep-label" style={{ display: "block", marginBottom: "0.65rem" }}>
//                 Working Hours (24-hour format)
//               </label>
//               <div className="ep-schedule-grid">
//                 <div className="ep-session-block">
//                   <div className="ep-session-title">🌅 Morning Session</div>
//                   <div className="ep-time-row">
//                     <Field label="Start Time">
//                       <TextField
//                         type="time" name="morningStartTime"
//                         value={scheduleValues.morningStartTime}
//                         onChange={(e) => {
//                           const t = e.target.value;
//                           setScheduleValues((p) => ({ ...p, morningStartTime: t }));
//                           setFormValues((p) => ({ ...p, MorStartTime: convertTo12HourFormat(t) }));
//                         }}
//                         InputLabelProps={{ shrink: true }} inputProps={{ step: 300 }}
//                         size="small" fullWidth
//                       />
//                     </Field>
//                     <Field label="End Time">
//                       <TextField
//                         type="time" name="morningEndTime"
//                         value={scheduleValues.morningEndTime}
//                         onChange={(e) => {
//                           const t = e.target.value;
//                           setScheduleValues((p) => ({ ...p, morningEndTime: t }));
//                           setFormValues((p) => ({ ...p, MorEndTime: convertTo12HourFormat(t) }));
//                         }}
//                         InputLabelProps={{ shrink: true }} inputProps={{ step: 300 }}
//                         size="small" fullWidth
//                       />
//                     </Field>
//                   </div>
//                 </div>

//                 <div className="ep-session-block">
//                   <div className="ep-session-title">🌇 Evening Session</div>
//                   <div className="ep-time-row">
//                     <Field label="Start Time">
//                       <TextField
//                         type="time" name="eveningStartTime"
//                         value={scheduleValues.eveningStartTime}
//                         onChange={(e) => {
//                           const t = e.target.value;
//                           setScheduleValues((p) => ({ ...p, eveningStartTime: t }));
//                           setFormValues((p) => ({ ...p, EveStartTime: convertTo12HourFormat(t) }));
//                         }}
//                         InputLabelProps={{ shrink: true }} inputProps={{ step: 300 }}
//                         size="small" fullWidth
//                       />
//                     </Field>
//                     <Field label="End Time">
//                       <TextField
//                         type="time" name="eveningEndTime"
//                         value={scheduleValues.eveningEndTime}
//                         onChange={(e) => {
//                           const t = e.target.value;
//                           setScheduleValues((p) => ({ ...p, eveningEndTime: t }));
//                           setFormValues((p) => ({ ...p, EveEndTime: convertTo12HourFormat(t) }));
//                         }}
//                         InputLabelProps={{ shrink: true }} inputProps={{ step: 300 }}
//                         size="small" fullWidth
//                       />
//                     </Field>
//                   </div>
//                 </div>
//               </div>
//             </Section>

//             {/* ── ABOUT ── */}
//             <Section icon="📝" title="About & Description">
//               <Field label="Describe yourself and your clinic">
//                 <textarea
//                   className="ep-input ep-textarea" name="Description"
//                   value={formValues.Description} onChange={handleInputChange}
//                   placeholder="Write about your expertise, approach to patient care, clinic facilities…"
//                   rows={4}
//                 />
//               </Field>
//             </Section>

//             {/* ── CLINIC PHOTOS ── */}
//             <Section icon="🖼️" title="Clinic Photos">
//               <div style={{ display: "flex", gap: "0.85rem", alignItems: "flex-end", flexWrap: "wrap" }}>
//                 <div style={{ flex: 1, minWidth: 200 }}>
//                   <Field label="Upload Clinic Photos">
//                     <input
//                       type="file" accept="image/*" multiple className="ep-file-input"
//                       onChange={(e) => setClinicImageFiles(Array.from(e.target.files))}
//                       disabled={uploadingClinicImages}
//                     />
//                   </Field>
//                 </div>
//                 <button
//                   type="button" className="ep-btn ep-btn-primary"
//                   onClick={handleClinicImageUpload} disabled={uploadingClinicImages}
//                 >
//                   {uploadingClinicImages ? "Saving…" : "📤 Upload"}
//                 </button>
//               </div>
//               {clinicImageUrls.length > 0 && (
//                 <div className="clinic-images-grid">
//                   {clinicImageUrls.map((url, idx) => (
//                     <div key={idx} className="clinic-img-item">
//                       <img src={url} alt={`Clinic ${idx + 1}`} />
//                       <button type="button" className="clinic-img-del"
//                         onClick={() => handleClinicImageDelete(idx)}>✕</button>
//                     </div>
//                   ))}
//                 </div>
//               )}
//             </Section>

//             {/* ── FOOTER ── */}
//             <div className="ep-form-footer">
//               <button type="submit" className="ep-btn ep-btn-primary" disabled={loading}>
//                 {loading ? "Saving…" : "💾 Save Profile & Schedule"}
//               </button>
//               <button type="button" className="ep-btn ep-btn-outline"
//                 onClick={() => history.push(`/Licence/${id}`)}>
//                 Next →
//               </button>
//             </div>

//           </form>
//         </div>
//       </Box>
//     </Box>
//   );
// };

// export default EditProfile;
import React, { useState, useEffect } from "react";
import { useParams, useHistory } from "react-router-dom";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import { getDatabase, ref, get, set, onValue, push } from "firebase/database";
import { app, database } from "../../Firebase/firebase.config";
import SideNav from "../SideNav";
import { toast, Toaster } from "react-hot-toast";
import dp from "../../image/dp.png";
import "./editprofile.css";

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}));

const convertTo12HourFormat = (time24) => {
  if (!time24) return "";
  let [hours, minutes] = time24.split(":");
  hours = parseInt(hours, 10);
  const suffix = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12;
  return `${hours}:${minutes} ${suffix}`;
};

const MONTHS = [
  "January","February","March","April","May","June",
  "July","August","September","October","November","December",
];

/* Normalize any stored date → YYYY-MM-DD for <input type="date"> */
const toInputDate = (val) => {
  if (!val) return "";
  if (typeof val === "string" && val.includes("T")) return val.split("T")[0];
  if (/^\d{4}-\d{2}-\d{2}$/.test(val)) return val;
  if (/^\d{2}-\d{2}-\d{4}$/.test(val)) {
    const [d, m, y] = val.split("-");
    return `${y}-${m}-${d}`;
  }
  if (/^\d{2}\/\d{2}\/\d{4}$/.test(val)) {
    const [m, d, y] = val.split("/");
    return `${y}-${m}-${d}`;
  }
  return val;
};

/* YYYY-MM-DD → "15 March 2026" */
const prettyDate = (val) => {
  const normalized = toInputDate(val);
  if (!normalized) return "";
  const [y, m, d] = normalized.split("-");
  const monthName = MONTHS[parseInt(m, 10) - 1] || m;
  return `${parseInt(d, 10)} ${monthName} ${y}`;
};

/* Compress image → base64 string (keeps DB size small) */
const compressImage = (file, maxWidth = 400, quality = 0.75) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = reject;
    reader.onload = (e) => {
      const img = new Image();
      img.onerror = reject;
      img.onload = () => {
        const scale = Math.min(1, maxWidth / img.width);
        const canvas = document.createElement("canvas");
        canvas.width = Math.round(img.width * scale);
        canvas.height = Math.round(img.height * scale);
        canvas.getContext("2d").drawImage(img, 0, 0, canvas.width, canvas.height);
        resolve(canvas.toDataURL("image/jpeg", quality));
      };
      img.src = e.target.result;
    };
    reader.readAsDataURL(file);
  });

/* ── Reusable Field ── */
const Field = ({ label, children }) => (
  <div className="ep-form-group">
    <label className="ep-label">{label}</label>
    {children}
  </div>
);

/* ── Reusable Section ── */
const Section = ({ icon, title, children }) => (
  <div className="ep-section">
    <div className="ep-section-header">
      <div className="ep-section-icon">{icon}</div>
      <h3>{title}</h3>
    </div>
    <div className="ep-section-body">{children}</div>
  </div>
);

const EditProfile = () => {
  const { id } = useParams();
  const history = useHistory();

  const [formValues, setFormValues] = useState({
    Prefix: "", First: "", Middle: "", Last: "",
    Email: "", Mobile: "", Description: "",
    Qualification1: "", Speciality: "",
    Speciality2: "", Speciality3: "", Speciality4: "",
    ClinicName: "", ClinicAddress: "", City: "",
    State: "", Country: "", Locality: "",
    Experience: "", MorStartTime: "", MorEndTime: "",
    EveStartTime: "", EveEndTime: "",
    DateOfBirth: "", Age: "",
    Fees: "", // ── Consultation fee
  });

  const [scheduleValues, setScheduleValues] = useState({
    startDate: "", endDate: "",
    morningStartTime: "", morningEndTime: "",
    eveningStartTime: "", eveningEndTime: "",
    isActive: true,
  });

  const [profileImageFile, setProfileImageFile] = useState(null);
  const [profileImageUrl, setProfileImageUrl] = useState("");
  const [clinicImageFiles, setClinicImageFiles] = useState([]);
  const [clinicImageUrls, setClinicImageUrls] = useState([]);
  const [loading, setLoading] = useState(false);
  const [uploadingProfileImage, setUploadingProfileImage] = useState(false);
  const [uploadingClinicImages, setUploadingClinicImages] = useState(false);

  useEffect(() => {
    if (!id) return;
    const dbRef = getDatabase(app);

    const fetchProfile = async () => {
      try {
        const snap = await get(ref(dbRef, `doctor/${id}`));
        if (snap.exists()) setFormValues(snap.val());
      } catch {
        toast.error("Failed to fetch profile");
      }
    };

    const fetchSchedule = async () => {
      try {
        const snap = await get(ref(dbRef, `doctor/${id}/schedule`));
        if (snap.exists()) {
          const data = snap.val();
          const key = Object.keys(data)[0];
          if (key) setScheduleValues(data[key]);
        } else {
          setScheduleValues({
            startDate: new Date().toISOString().split("T")[0],
            endDate: new Date(
              new Date().setFullYear(new Date().getFullYear() + 1)
            ).toISOString().split("T")[0],
            morningStartTime: "10:00",
            morningEndTime: "12:00",
            eveningStartTime: "15:00",
            eveningEndTime: "20:00",
            isActive: true,
          });
        }
      } catch (e) {
        console.error(e);
      }
    };

    /* Real-time listeners → images auto-load on every login */
    const unsubProfile = onValue(
      ref(database, `Profile/${id}/Profile`),
      (snap) => setProfileImageUrl(snap.val()?.base64 || "")
    );
    const unsubClinic = onValue(
      ref(database, `Profile/${id}/Clinic`),
      (snap) => setClinicImageUrls(snap.val()?.images || [])
    );

    fetchProfile();
    fetchSchedule();
    return () => { unsubProfile(); unsubClinic(); };
  }, [id]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormValues((p) => ({ ...p, [name]: value }));
  };

  const handleScheduleChange = (e) => {
    const { name, value } = e.target;
    setScheduleValues((p) => ({ ...p, [name]: value }));
  };

  /* Profile photo: compress → base64 → save to Realtime DB */
  const handleProfileImageUpload = async () => {
    if (!profileImageFile) { toast.error("Please choose an image"); return; }
    setUploadingProfileImage(true);
    try {
      const base64 = await compressImage(profileImageFile, 400, 0.75);
      await set(ref(database, `Profile/${id}/Profile`), { base64 });
      setProfileImageUrl(base64);
      toast.success("Profile photo saved!");
    } catch (err) {
      console.error(err);
      toast.error("Save failed: " + (err.message || "unknown error"));
    }
    setUploadingProfileImage(false);
  };

  const handleProfileImageDelete = async () => {
    if (!profileImageUrl) { toast.error("No image to delete"); return; }
    try {
      await set(ref(database, `Profile/${id}/Profile`), { base64: null });
      setProfileImageUrl("");
      toast.success("Photo removed");
    } catch {
      toast.error("Delete failed");
    }
  };

  /* Clinic photos: compress → base64 array → save to Realtime DB */
  const handleClinicImageUpload = async () => {
    if (!clinicImageFiles.length) { toast.error("Please choose images"); return; }
    setUploadingClinicImages(true);
    try {
      const newBase64s = await Promise.all(
        clinicImageFiles.map((f) => compressImage(f, 600, 0.7))
      );
      const updated = [...clinicImageUrls, ...newBase64s];
      await set(ref(database, `Profile/${id}/Clinic`), { images: updated });
      setClinicImageUrls(updated);
      toast.success("Clinic photos saved!");
    } catch (err) {
      console.error(err);
      toast.error("Save failed");
    }
    setUploadingClinicImages(false);
  };

  const handleClinicImageDelete = async (index) => {
    try {
      const updated = clinicImageUrls.filter((_, i) => i !== index);
      await set(ref(database, `Profile/${id}/Clinic`), { images: updated });
      setClinicImageUrls(updated);
      toast.success("Image removed");
    } catch {
      toast.error("Delete failed");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const dbRef = getDatabase(app);
      await set(ref(dbRef, `doctor/${id}`), formValues);
      const schedRef = ref(dbRef, `doctor/${id}/schedule`);
      const schedSnap = await get(schedRef);
      const key = schedSnap.exists()
        ? Object.keys(schedSnap.val())[0]
        : push(schedRef).key;
      await set(ref(dbRef, `doctor/${id}/schedule/${key}`), scheduleValues);
      toast.success("Profile & schedule saved!");
      history.push(`/payment/${id}`);
    } catch {
      toast.error("Save failed");
    }
    setLoading(false);
  };

  const requiredProfileFields = [
    'First', 'Last', 'Email', 'Mobile', 'ClinicName', 'ClinicAddress',
    'City', 'State', 'Country', 'Qualification1', 'Speciality',
    'Experience', 'Fees', 'Description'
  ];

  const isProfileComplete = requiredProfileFields.every((key) => {
    const value = formValues[key];
    return typeof value === 'string'
      ? value.trim().length > 0
      : Boolean(value);
  }) && Boolean(profileImageUrl);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      localStorage.setItem('profileIncomplete', isProfileComplete ? 'false' : 'true');
    }
  }, [isProfileComplete]);

  const fullName = [formValues.First, formValues.Middle, formValues.Last]
    .filter(Boolean).join(" ");

  return (
    <Box sx={{ display: "flex" }}>
      <SideNav id={id} />

      <Box
        component="main"
        className="ep-page-bg"
        sx={{ flexGrow: 1, minWidth: 0, py: 2, px: 0 }}
      >
        <DrawerHeader />
        <Toaster toastOptions={{ duration: 4000 }} />

        <div className="ep-wrapper">
          {!isProfileComplete && (
            <div style={{
              marginBottom: 18,
              padding: '16px 18px',
              borderRadius: 12,
              background: '#FEF3C7',
              border: '1px solid #FDE68A',
              color: '#92400E',
              lineHeight: 1.5,
            }}>
              <strong>Registration complete.</strong> Your profile is still incomplete.
              Please fill in the missing details and upload a profile photo to receive more appointments.
            </div>
          )}
          <form onSubmit={handleSubmit}>

            <div className="ep-header">
              <h1>My Profile</h1>
              <div className="ep-header-line" />
            </div>

            {/* ── PERSONAL INFO ── */}
            <div className="ep-section">
              <div className="ep-section-header">
                <div className="ep-section-icon">👤</div>
                <h3>Personal Information</h3>
              </div>
              <div className="ep-section-body">
                <div className="ep-personal-layout">

                  {/* Photo card */}
                  <div className="ep-photo-card">
                    <div className="ep-avatar-wrap">
                      <img
                        src={profileImageUrl || dp}
                        alt="Profile"
                        className="ep-avatar"
                      />
                      <div className="ep-avatar-badge">📷</div>
                    </div>
                    {fullName && <div className="ep-photo-name">{fullName}</div>}
                    <div className="ep-photo-actions">
                      <input
                        type="file"
                        accept="image/*"
                        className="ep-file-input"
                        onChange={(e) => setProfileImageFile(e.target.files[0])}
                      />
                      <button
                        type="button"
                        className="ep-btn ep-btn-primary ep-btn-sm ep-btn-full"
                        onClick={handleProfileImageUpload}
                        disabled={uploadingProfileImage}
                      >
                        {uploadingProfileImage ? "Saving…" : "📤 Upload Photo"}
                      </button>
                      {profileImageUrl && (
                        <button
                          type="button"
                          className="ep-btn ep-btn-danger ep-btn-sm ep-btn-full"
                          onClick={handleProfileImageDelete}
                        >
                          🗑 Remove
                        </button>
                      )}
                    </div>
                  </div>

                  {/* Fields */}
                  <div style={{ display: "flex", flexDirection: "column", gap: "0.85rem" }}>
                    <div className="ep-grid-3">
                      <Field label="First Name">
                        <input
                          className="ep-input" type="text" name="First"
                          value={formValues.First} onChange={handleInputChange}
                          placeholder="First Name" required
                        />
                      </Field>
                      <Field label="Middle Name">
                        <input
                          className="ep-input" type="text" name="Middle"
                          value={formValues.Middle} onChange={handleInputChange}
                          placeholder="Middle Name"
                        />
                      </Field>
                      <Field label="Last Name">
                        <input
                          className="ep-input" type="text" name="Last"
                          value={formValues.Last} onChange={handleInputChange}
                          placeholder="Last Name" required
                        />
                      </Field>
                    </div>
                    <div className="ep-grid-2">
                      <Field label="Email Address">
                        <input
                          className="ep-input" type="email"
                          value={formValues.Email || ""} disabled placeholder="Email"
                        />
                      </Field>
                      <Field label="Mobile Number">
                        <input
                          className="ep-input" type="text" name="Mobile"
                          value={formValues.Mobile || ""} onChange={handleInputChange}
                          placeholder="Mobile Number"
                        />
                      </Field>
                    </div>
                    <div className="ep-grid-2">
                      <Field label="Date of Birth">
                        <input
                          className="ep-input" type="date" name="DateOfBirth"
                          value={toInputDate(formValues.DateOfBirth)}
                          onChange={handleInputChange}
                        />
                        {formValues.DateOfBirth && (
                          <span className="ep-date-pretty">
                            {prettyDate(formValues.DateOfBirth)}
                          </span>
                        )}
                      </Field>
                      <Field label="Age">
                        <input
                          className="ep-input" type="number" name="Age"
                          value={formValues.Age} onChange={handleInputChange}
                          placeholder="Age"
                        />
                      </Field>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* ── QUALIFICATIONS ── */}
            <Section icon="🎓" title="Qualifications & Specialities">
              <div className="ep-grid-2" style={{ marginBottom: "0.85rem" }}>
                <Field label="Primary Qualification">
                  <input
                    className="ep-input" type="text" name="Qualification1"
                    value={formValues.Qualification1} onChange={handleInputChange}
                    placeholder="e.g. MBBS, MD"
                  />
                </Field>
                <Field label="Primary Speciality">
                  <input
                    className="ep-input" type="text" name="Speciality"
                    value={formValues.Speciality} onChange={handleInputChange}
                    placeholder="e.g. Cardiology"
                  />
                </Field>
              </div>
              <label className="ep-label" style={{ display: "block", marginBottom: "0.45rem" }}>
                Additional Specialities (Optional)
              </label>
              <div className="ep-grid-3">
                <input className="ep-input" type="text" name="Speciality2"
                  value={formValues.Speciality2} onChange={handleInputChange} placeholder="Speciality 2" />
                <input className="ep-input" type="text" name="Speciality3"
                  value={formValues.Speciality3} onChange={handleInputChange} placeholder="Speciality 3" />
                <input className="ep-input" type="text" name="Speciality4"
                  value={formValues.Speciality4} onChange={handleInputChange} placeholder="Speciality 4" />
              </div>
            </Section>

            {/* ── CLINIC DETAILS ── */}
            <Section icon="🏥" title="Clinic Details">
              <div className="ep-grid-3" style={{ marginBottom: "0.85rem" }}>
                <Field label="Clinic Name">
                  <input className="ep-input" type="text" name="ClinicName"
                    value={formValues.ClinicName} onChange={handleInputChange} placeholder="Clinic Name" />
                </Field>
                <Field label="Clinic Address">
                  <input className="ep-input" type="text" name="ClinicAddress"
                    value={formValues.ClinicAddress} onChange={handleInputChange} placeholder="Street / Area" />
                </Field>
                <Field label="Experience (Years)">
                  <input className="ep-input" type="number" name="Experience"
                    value={formValues.Experience} onChange={handleInputChange} placeholder="e.g. 5" />
                </Field>
              </div>
              <div className="ep-grid-4" style={{ marginBottom: "0.85rem" }}>
                <Field label="Locality">
                  <input className="ep-input" type="text" name="Locality"
                    value={formValues.Locality} onChange={handleInputChange} placeholder="Locality" />
                </Field>
                <Field label="City">
                  <input className="ep-input" type="text" name="City"
                    value={formValues.City} onChange={handleInputChange} placeholder="City" />
                </Field>
                <Field label="State">
                  <input className="ep-input" type="text" name="State"
                    value={formValues.State} onChange={handleInputChange} placeholder="State" />
                </Field>
                <Field label="Country">
                  <input className="ep-input" type="text" name="Country"
                    value={formValues.Country} onChange={handleInputChange} placeholder="Country" />
                </Field>
              </div>

              {/* ── CONSULTATION FEE ── */}
              <div className="ep-grid-2">
                <Field label="Consultation Fees (₹)">
                  <input
                    className="ep-input" type="number" name="Fees"
                    value={formValues.Fees} onChange={handleInputChange}
                    placeholder="e.g. 500" min="0"
                  />
                </Field>
              </div>
            </Section>

            {/* ── WORKING SCHEDULE ── */}
            <Section icon="📅" title="Working Schedule">
              <div className="ep-grid-2" style={{ marginBottom: "1rem" }}>
                <Field label="Schedule Start Date">
                  <input
                    className="ep-input" type="date" name="startDate"
                    value={toInputDate(scheduleValues.startDate)}
                    onChange={handleScheduleChange} required
                  />
                  {scheduleValues.startDate && (
                    <span className="ep-date-pretty">{prettyDate(scheduleValues.startDate)}</span>
                  )}
                </Field>
                <Field label="Schedule End Date">
                  <input
                    className="ep-input" type="date" name="endDate"
                    value={toInputDate(scheduleValues.endDate)}
                    onChange={handleScheduleChange} required
                  />
                  {scheduleValues.endDate && (
                    <span className="ep-date-pretty">{prettyDate(scheduleValues.endDate)}</span>
                  )}
                </Field>
              </div>
              <label className="ep-label" style={{ display: "block", marginBottom: "0.65rem" }}>
                Working Hours (24-hour format)
              </label>
              <div className="ep-schedule-grid">
                <div className="ep-session-block">
                  <div className="ep-session-title">🌅 Morning Session</div>
                  <div className="ep-time-row">
                    <Field label="Start Time">
                      <TextField
                        type="time" name="morningStartTime"
                        value={scheduleValues.morningStartTime}
                        onChange={(e) => {
                          const t = e.target.value;
                          setScheduleValues((p) => ({ ...p, morningStartTime: t }));
                          setFormValues((p) => ({ ...p, MorStartTime: convertTo12HourFormat(t) }));
                        }}
                        InputLabelProps={{ shrink: true }} inputProps={{ step: 300 }}
                        size="small" fullWidth
                      />
                    </Field>
                    <Field label="End Time">
                      <TextField
                        type="time" name="morningEndTime"
                        value={scheduleValues.morningEndTime}
                        onChange={(e) => {
                          const t = e.target.value;
                          setScheduleValues((p) => ({ ...p, morningEndTime: t }));
                          setFormValues((p) => ({ ...p, MorEndTime: convertTo12HourFormat(t) }));
                        }}
                        InputLabelProps={{ shrink: true }} inputProps={{ step: 300 }}
                        size="small" fullWidth
                      />
                    </Field>
                  </div>
                </div>

                <div className="ep-session-block">
                  <div className="ep-session-title">🌇 Evening Session</div>
                  <div className="ep-time-row">
                    <Field label="Start Time">
                      <TextField
                        type="time" name="eveningStartTime"
                        value={scheduleValues.eveningStartTime}
                        onChange={(e) => {
                          const t = e.target.value;
                          setScheduleValues((p) => ({ ...p, eveningStartTime: t }));
                          setFormValues((p) => ({ ...p, EveStartTime: convertTo12HourFormat(t) }));
                        }}
                        InputLabelProps={{ shrink: true }} inputProps={{ step: 300 }}
                        size="small" fullWidth
                      />
                    </Field>
                    <Field label="End Time">
                      <TextField
                        type="time" name="eveningEndTime"
                        value={scheduleValues.eveningEndTime}
                        onChange={(e) => {
                          const t = e.target.value;
                          setScheduleValues((p) => ({ ...p, eveningEndTime: t }));
                          setFormValues((p) => ({ ...p, EveEndTime: convertTo12HourFormat(t) }));
                        }}
                        InputLabelProps={{ shrink: true }} inputProps={{ step: 300 }}
                        size="small" fullWidth
                      />
                    </Field>
                  </div>
                </div>
              </div>
            </Section>

            {/* ── ABOUT ── */}
            <Section icon="📝" title="About & Description">
              <Field label="Describe yourself and your clinic">
                <textarea
                  className="ep-input ep-textarea" name="Description"
                  value={formValues.Description} onChange={handleInputChange}
                  placeholder="Write about your expertise, approach to patient care, clinic facilities…"
                  rows={4}
                />
              </Field>
            </Section>

            {/* ── CLINIC PHOTOS ── */}
            <Section icon="🖼️" title="Clinic Photos">
              <div style={{ display: "flex", gap: "0.85rem", alignItems: "flex-end", flexWrap: "wrap" }}>
                <div style={{ flex: 1, minWidth: 200 }}>
                  <Field label="Upload Clinic Photos">
                    <input
                      type="file" accept="image/*" multiple className="ep-file-input"
                      onChange={(e) => setClinicImageFiles(Array.from(e.target.files))}
                      disabled={uploadingClinicImages}
                    />
                  </Field>
                </div>
                <button
                  type="button" className="ep-btn ep-btn-primary"
                  onClick={handleClinicImageUpload} disabled={uploadingClinicImages}
                >
                  {uploadingClinicImages ? "Saving…" : "📤 Upload"}
                </button>
              </div>
              {clinicImageUrls.length > 0 && (
                <div className="clinic-images-grid">
                  {clinicImageUrls.map((url, idx) => (
                    <div key={idx} className="clinic-img-item">
                      <img src={url} alt={`Clinic ${idx + 1}`} />
                      <button type="button" className="clinic-img-del"
                        onClick={() => handleClinicImageDelete(idx)}>✕</button>
                    </div>
                  ))}
                </div>
              )}
            </Section>

            {/* ── FOOTER ── */}
            <div className="ep-form-footer">
              <button type="submit" className="ep-btn ep-btn-primary" disabled={loading}>
                {loading ? "Saving…" : "💾 Save Profile & Schedule"}
              </button>
              <button type="button" className="ep-btn ep-btn-outline"
                onClick={() => history.push(`/payment/${id}`)}>
                Payment →
              </button>
            </div>

          </form>
        </div>
      </Box>
    </Box>
  );
};

export default EditProfile;